<template>
  <FlyText
    v-bind="{ ...TEXT_VARIANTS_ENUM.UI_XSMALL, ...borderProps }"
    :bg-color="bgColor"
    :color="textColor"
    :border-radius="BORDER_RADIUS_ENUM['12']"
    padding-horizontal="6"
    :style="{ paddingTop: '2px', paddingBottom: '2px' }"
    flex-align="center"
  >
    {{ statusText }}
  </FlyText>
</template>

<script>
import VueTypes from 'vue-types';
import FlyText from 'shared/components/Text/FlyText';
import PIPELINE_STATUS_ENUM from 'web/pipelines/PIPELINE_STATUS_ENUM';
import { startCase } from 'lodash';
import COLOR_ENUM from 'shared/components/Color/COLOR_ENUM';
import BORDER_WIDTH_ENUM from 'shared/components/Border/BORDER_WIDTH_ENUM';
import BORDER_STYLE_ENUM from 'shared/components/Border/BORDER_STYLE_ENUM';
export default {
  name: 'PipelineStatusLabel',
  components: {
    FlyText,
  },
  props: {
    status: VueTypes.string.isRequired,
  },
  computed: {
    bgColor() {
      if (this.status === PIPELINE_STATUS_ENUM.RUNNING) {
        return COLOR_ENUM.GREEN_1;
      }

      if (this.status === PIPELINE_STATUS_ENUM.PAUSING) {
        return COLOR_ENUM.GREY_6;
      }

      if (this.status === PIPELINE_STATUS_ENUM.PAUSED) {
        return COLOR_ENUM.GREY_7;
      }

      if (this.status === PIPELINE_STATUS_ENUM.ERRORED) {
        return COLOR_ENUM.RED_3;
      }

      if (this.status === PIPELINE_STATUS_ENUM.DRAFT) {
        return COLOR_ENUM.WHITE;
      }

      return COLOR_ENUM.GREY_7;
    },
    textColor() {
      if (this.status === PIPELINE_STATUS_ENUM.DRAFT) {
        return COLOR_ENUM.BLUE_1;
      }
      if (this.status === PIPELINE_STATUS_ENUM.PAUSED) {
        return COLOR_ENUM.GREY_4;
      }
      if (this.status === PIPELINE_STATUS_ENUM.STARTING) {
        return COLOR_ENUM.GREY_4;
      }
      if (this.status === PIPELINE_STATUS_ENUM.PAUSING) {
        return COLOR_ENUM.GREY_4;
      }
      if (this.status === PIPELINE_STATUS_ENUM.ARCHIVED) {
        return COLOR_ENUM.GREY_4;
      }
      return COLOR_ENUM.WHITE;
    },
    borderProps() {
      if (this.status === PIPELINE_STATUS_ENUM.DRAFT) {
        return {
          borderWidth: BORDER_WIDTH_ENUM['1'],
          borderStyle: BORDER_STYLE_ENUM.SOLID,
          borderColor: COLOR_ENUM.BLUE_1,
        };
      }
      return {
        borderWidth: BORDER_WIDTH_ENUM['1'],
        borderStyle: BORDER_STYLE_ENUM.SOLID,
        borderColor: this.bgColor,
      };
    },
    statusText() {
      if (this.status === PIPELINE_STATUS_ENUM.RUNNING) {
        return 'Active';
      }

      if (this.status === PIPELINE_STATUS_ENUM.PAUSED) {
        return 'Paused';
      }

      if (this.status === PIPELINE_STATUS_ENUM.ERRORED) {
        return 'Sync Error';
      }

      return startCase(this.status);
    },
  },
};
</script>

<style lang="scss"></style>
